module.exports = __webpack_public_path__ + "static/media/user-white.d33cc82a.svg";